export default __webpack_public_path__ + "static/media/vietcombank.db765a59.jpg";